import type { MouseEvent } from 'react';

/**
 * Открывает адрес новой вкладкой, а не отдельным окном.
 *
 * `window.open` во время обработки shift+клика браузер трактует по-своему — как «открыть
 * в отдельном окне», и модификатор доходит до него независимо от намерения вызова. Клик по
 * созданной ссылке модификаторов не несёт: браузер смотрит на событие, а не на клавиатуру,
 * поэтому открывается именно вкладка.
 */
export const openUrlInNewTab = (url: string): void => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Подавляет выделение текста, которое операционная система тянет за shift+кликом.
 *
 * Вешается на `onMouseDown` элемента, у которого shift+клик — переход: иначе переход
 * оставляет за собой выделенные строки, и снимать их пользователю приходится самому.
 */
export const preventShiftSelection = (event: MouseEvent): void => {
  if (event.shiftKey) event.preventDefault();
};
